import React, { useState, useEffect } from "react";
import Iframe from 'react-iframe'

import env from "react-dotenv";

import dataProvider from "../../services/DataProvider";

import Navigation from "../../components/Navigation";

import FormExterno from "../../components/FormExterno";


const GeradorRelatorios = () => {

    const [src, setSrc] = useState([])

    
    useEffect(() => {
       setSrc(env.REACT_APP_GERADOR_RELATORIOS_URL)
    }, []);
    
    return (
        <>
            <Navigation titulo="Gerador de Relatórios" />
            <FormExterno src={src} />
        </>
    )
}

export default GeradorRelatorios;
